export const MAX_ELEMENTS_PER_PAGE = 10;
export const MAX_VARCHAR_LENGTH = 255;
export const MAX_TEXT_LENGTH = 65535;
